import React from 'react';
import { useIntl } from 'react-intl';
import { CloseIcon } from '@panwds/icons';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import { Badge } from '../Badge/Badge.esm.js';
import '../Icon/ImgIcon.esm.js';
import { InfoIcon, SuccessIcon, WarningIcon, DangerIcon } from '../Icon/SemanticIcons.esm.js';

const BannerBadge = () => {
    return (React.createElement(Badge, { overrideAppearance: "tw-py-0 tw-px-1 tw-bg-blue-600", appearance: "blue" }, "New"));
};
const icons = {
    new: BannerBadge,
    standard: InfoIcon,
    success: SuccessIcon,
    warning: WarningIcon,
    error: DangerIcon,
};
const containerStyles = {
    new: "tw-bg-blue-100 dark:tw-bg-blue-800",
    standard: "tw-bg-blue-100 dark:tw-bg-blue-800",
    success: "tw-bg-teal-100 dark:tw-bg-teal-800",
    warning: "tw-bg-yellow-100 dark:tw-bg-yellow-800",
    error: "tw-bg-red-100 dark:tw-bg-red-800",
};
const pageBorders = {
    new: "tw-border-blue-600 dark:tw-border-blue-400",
    standard: "tw-border-blue-600 dark:tw-border-blue-400",
    success: "tw-border-teal-400",
    warning: "tw-border-yellow-300",
    error: "tw-border-red-500",
};
const Banner = (props) => {
    const { appearance = "standard", children, dataMetrics, dataTestId, onClose, showIcon = false, type = "inline", ...rest } = props;
    const intl = useIntl();
    const containerClasses = classNames("tw-flex tw-p-3 tw-font-lato tw-text-xs dark:tw-text-gray-100", type === "inline" && "tw-inline", containerStyles[appearance], type === "page" &&
        "tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-b-2", type === "page" && pageBorders[appearance]);
    const Icon = icons[appearance];
    return (React.createElement("div", { role: "banner", "data-metrics": dataMetrics, "data-testid": dataTestId ||
            `banner-${typeof children === "string" && testIdGen(children)}`, ...rest, className: containerClasses },
        showIcon && (React.createElement("div", { className: "tw-mr-3 tw-flex" },
            React.createElement(Icon, { "aria-hidden": true, appearance: "light" }))),
        React.createElement("div", { className: "tw-flex-grow tw-flex tw-self-center" }, children),
        onClose && (React.createElement("div", null,
            React.createElement("button", { "aria-label": intl.formatMessage({ id: "4Cv5mw", defaultMessage: [{ type: 0, value: "Close" }] }), onClick: onClose, className: "tw-box-border tw-bg-transparent tw-cursor-pointer tw-border-0 tw-m-0 tw-p-0 tw-ml-4 tw-text-secondary hover:tw-text-default focus:tw-ring focus:tw-outline-none tw-rounded" },
                React.createElement(CloseIcon, { size: "xs", className: "dark:tw-text-gray-100" }))))));
};

export { Banner };
//# sourceMappingURL=Banner.esm.js.map
